import { render } from "./PrescriptionsSection.vue?vue&type=template&id=77c5e72a"
import script from "./PrescriptionsSection.vue?vue&type=script&lang=js"
export * from "./PrescriptionsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__